export const ICON_FAMILY_APPLICATIONS = "applications";
export const ICON_HEIGHT = 48;
export const ICON_WIDTH = 48;
